import React, { useState } from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { Link } from 'react-router-dom'

import { FaChevronRight, FaStar, FaUserAlt, FaWallet, FaRegBuilding } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import Form from 'react-bootstrap/Form';
import { BsFillCheckCircleFill, BsArrowRight } from "react-icons/bs";
import HowItWorksImg from './../Images/how-it-works.png';

import Layout1 from './../Images/layout1.png';
import Accordion from 'react-bootstrap/Accordion';





function InvestmentSummary() {
    const [showMore, setShowMore] = useState(false);
    const [showMore2, setShowMore2] = useState(false);
    const [showMore3, setShowMore3] = useState(false);
    return (
        <>
            <Header />
            <div className="banner w-100 mb-90" style={{ backgroundImage: `url(${HowItWorksImg})` }}>
                <div className="container">
                    <div className="banner-title text-center">
                        <h1>Investment Summary</h1>
                        <p><Link to="/">Home</Link> <span><FaChevronRight /></span> Investment Summary</p>
                    </div>
                </div>
            </div>




            {/* general description starts */}

            <div className="summary">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 pe-lg-5">
                            <div className="gen-desc mb-30 ps-0">
                                <h2>investment  options</h2>
                            </div>
                            <div className="overview-acc mb-60">
                                <Form.Select aria-label="Default select example">
                                    <option>Open this select menu</option>
                                    <option className='red' value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </Form.Select>

                            </div>
                            <div className="gen-desc mb-30">
                                <h2>Summary</h2>
                            </div>
                            <div className="border-bx mb-4">
                                <div className="overview-header">

                                    <div className=" row text-center px-md-4 px-2 py-3">

                                        <div className="col-4">
                                            <div className="overview-head">
                                                <h4>15 yr</h4>
                                                <p>Lease Period</p>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="overview-head">
                                                <h4>2022-06-30</h4>
                                                <p>Lock in period</p>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="overview-head">
                                                <h4>15%</h4>
                                                <p>Current yield</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="property-name summary-name pt-4 property-title">
                                    <h2>Property 4</h2>
                                    <p><FiMapPin /> Agoda, surulere lagos</p>
                                </div>
                                <div className="overview-txt p-4">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irur.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 ps-lg-50">
                            <div className="border-bx mb-4">
                                <div className="overview-header">

                                    <div className=" text-center px-4 py-3">
                                        <div className="">
                                            <div className="overview-head">
                                                <h2>Selected Layout</h2>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="overview-txt p-40">
                                    <div className="summary-layout border-1 mb-3">
                                        <img src={Layout1} alt="" />
                                    </div>
                                    <div className="checkout">
                                        <ul>
                                            <li><span className="checklist">Area (Sqft)
                                            </span> <span className="price">100</span></li>
                                            <li><span className="checklist">Price Per (Sqft)
                                            </span> <span className="price">90</span></li>
                                            <li className="bord-bottom"></li>
                                            <li><span className="checklist">Total Investment
                                            </span> <span className="price">9000</span></li>
                                        </ul>
                                        <div className="checkout-btns d-flex justify-content-between">
                                            <Link className='layout-btn' to="">Change Layout</Link>
                                            <Link className='proceed-btn' to="">Proceed to pay</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" mb-60">
                <div className="container">

                </div>
            </div>
            {/* general description ends */}





            <Footer />
        </>


    )
}

export default InvestmentSummary